// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"525":"e34262cfdcc30ea8bbc1","853":"dce608827c6ef8e9a25c","879":"028df583476096aea7b1"}[chunkId] + ".js";
};